import { Button } from '@/components/Button';
import { MaterialIcon } from '@/components/MaterialIcon';

interface OnboardingWelcomeStepProps {
  onNext: () => void;
}

export default function OnboardingWelcomeStep({ onNext }: OnboardingWelcomeStepProps) {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-gray-100"
      style={{ backgroundColor: '#F4F6F9' }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-gray-300 opacity-50"
        style={{ backgroundColor: '#E7E7E7' }}
      >
        {/* Background Decorative Elements */}
        <div className="absolute inset-0 overflow-hidden">
          {/* Right-top blur - Purple */}
          <div
            className="absolute rounded-full"
            style={{
              background: '#EEE6F6',
              width: '796.91px',
              height: '630.18px',
              right: '-100px',
              top: '-100px',
              filter: 'blur(200px)',
            }}
          ></div>
          {/* Left-bottom blur - Blue */}
          <div
            className="absolute rounded-full"
            style={{
              background: '#C6E2F4',
              width: '796.91px',
              height: '630.18px',
              left: '-100px',
              bottom: '-100px',
              filter: 'blur(200px)',
            }}
          ></div>
        </div>
      </div>

      {/* Main Dialog */}
      <div
        className="relative z-10 mx-4 w-full overflow-hidden rounded-md bg-white shadow-xl"
        style={{
          maxWidth: '640px',
          boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.2)',
        }}
      >
        {/* Content */}
        <div className="relative z-10 flex h-full flex-col items-center">
          {/* イラスト部分 */}
          <div
            className="flex w-full flex-col items-center justify-center rounded-t-lg bg-[#DEF6FF]"
            style={{ height: 320 }}
          >
            <img
              src="/agent/onboarding/onboarding-image.png"
              alt="オンボーディングイラスト"
              className="w-full"
              style={{ height: 320 }}
            />
          </div>
          {/* テキスト部分 */}
          <div className="flex w-full flex-col items-center gap-8 px-16 py-8">
            <h2 className="my-0 text-center text-2xl font-bold text-black">
              エージェントハブにようこそ！
            </h2>
            <p
              className="text-left text-base leading-7 font-normal text-black"
              style={{ whiteSpace: 'pre-line' }}
            >
              アカウント登録が完了しました。
              <br />
              エージェントハブでは求職者獲得から採用決定まで、転職支援業務にまつわる多くの業務をサポートする機能を提供しています。
              <br />
              <br />
              まずは必要なところから、少しずつご利用を始めてみてください。
            </p>
            <Button
              type="button"
              color="primary"
              size="lg"
              className="relative flex h-[52px] w-[240px] items-center justify-center font-bold"
              onClick={onNext}
            >
              次へ
              <MaterialIcon name="keyboard_arrow_right" className="absolute right-md text-lg" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
